//Generated File 
export default class URLRequestParameters{
	static readonly ANALYSIS_SET = `an`;
	static readonly BRANCH = `br`;
	static readonly DEPARTMENT = `dep`;
	static readonly LEGAL_ENTITY = `leg`;
	static readonly LOCALE = `locale`;
	static readonly LOGIN_ID = `lId`;
	static readonly OTP_ID = `otId`;
	static readonly PASSWORD = `p`;
	static readonly SECTOR = `sc`;
	static readonly USER_ID = `uId`;
}
